import gql from 'graphql-tag'

export const GET_VEHICLE_DOCS = gql`
query VehicleDocs($filter: GetVehicleDocInputType!) {
  vehicleDocs(filter: $filter) {
    isSuccessful
    message
    vehicleDocs {
      licensePlate
      vehicleId
      docType
      docNumber
      validUntil
      status
    }
  }
}`

export const UPDATE_VEHICLE_DOCS = gql`
mutation UpdateVehicleDoc($input: CreateVehicleDocInput!) {
  updateVehicleDoc(input: $input) {
    isSuccessful
    message
    updateVehicleDoc {
      licensePlate
      vehicleId
      docType
      docNumber
      validUntil
      status
    }
  }
}`

export const IMPORT_VEHICLE_DOCS = gql`
mutation ImportVehicleDoc($input: ImportVehicleDocInput!) {
  importVehicleDoc(input: $input) {
    isSuccessful
    message
    importVehicleDoc {
      errorFile
      totalData
      totalFailed
      totalSuccess
    }
  }
}`

export const DOWNLOAD_EXCEL_VEHICLEDOCS = gql`
query DownloadvehicleDocs($filter: GetVehicleDocInputType!) {
  downloadvehicleDocs(filter: $filter) {
    isSuccessful
    message
    vehicleDocs {
      base64
    }
  }
}`